import * as Util from './util.js';

class Footer
{
  // ---------------------------------------------------------------------------------------------------------
	// --	Footer
	// ---------------------------------------------------------------------------------------------------------

  constructor(){

    //DOM参照
    this.footer = $("footer");
    this.pagetop = $(".pagetop");

    //PageTopボタンアクション
    this.pagetop.click((e)=>{
      e.preventDefault();
      Util.scrollTo("home");
    });

    //スクロールのハンドリング
    $(window).scroll(this.onScroll.bind(this));
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	スクロールのハンドリング
	// ---------------------------------------------------------------------------------------------------------

  onScroll(){

    //表示制御
    const half = $(window).outerHeight()/2;
    if($(window).scrollTop() > half)
    {
      this.pagetop.addClass("show");
    }
    else
    {
      this.pagetop.removeClass("show");
    }

    //ボトムの位置を変更
    const scrollY = $(window).scrollTop();
    let bottomOffset = -(Math.floor(this.footer.offset().top - scrollY) - window.innerHeight);
    if(bottomOffset < 0) bottomOffset = 0;
    this.pagetop.css("bottom", (bottomOffset + 30) + "px");
  }


  // ---------------------------------------------------------------------------------------------------------
	// --	リサイズ関連
	// ---------------------------------------------------------------------------------------------------------

  onResize(){
  }

  onDeviceChange(){
  }

  // ---------------------------------------------------------------------------------------------------------
}

export default Footer;
